import moment from "moment";

const BirthDateInput = ({ birth_date, onChange, className }) => {
  return (
    <div className="form-control">
      {!birth_date && (
        <span className="text-sm text-left mt-1">생년월일을 선택하세요.</span>
      )}
      <input
        id="birth_date"
        type="date"
        placeholder="생년월일"
        className={`input text-sm input-bordered ${className || ""}${
          birth_date ? " border-primary" : ""
        }`}
        min="1910-01-01"
        max={new moment().add(-1, "days").format("YYYY-MM-DD")}
        value={birth_date}
        onChange={onChange}
      />
    </div>
  );
};
export default BirthDateInput;
